import { signal } from '@angular/core';

export class Loader {
  isLoading = signal<boolean>(false);
  private loadingSet = new Set<string>();

  loading = (key: string) => {
    this.loadingSet.add(key);
    this.isLoading.set(this.loadingSet.size > 0);
  };

  finished = (key: string) => {
    this.loadingSet.delete(key);
    this.isLoading.set(this.loadingSet.size > 0);
  };
}

export const loading = () => new Loader();
